import { z } from 'zod';

import { calculateVenueCo2DtoSchema } from '../co2/dto.type';
import { calculateVenueEnvDtoSchema } from '../env/dto.type';
import { calculateVenueEssDtoSchema } from '../ess/dto.type';

export type ResultsVenueDto = z.infer<typeof resultsVenueDtoSchema>;

export const resultsVenueDtoSchema = z.object({
  totalAvgCapacity: z.number(),
  co2: calculateVenueCo2DtoSchema.optional(),
  countDates: z.number().optional(),
  env: calculateVenueEnvDtoSchema
    .extend({
      events: z.object({
        score: z.number(),
        maxScore: z.number(),
      }),
    })
    .optional(),
  ess: calculateVenueEssDtoSchema
    .extend({
      events: z.object({
        score: z.number(),
        maxScore: z.number(),
      }),
    })
    .optional(),
});
